module.exports = __webpack_public_path__ + "img/container_rear_left.b5dd210d.svg";